// extracted by mini-css-extract-plugin
export default {"googleLogo":"GoogleButton_googleLogo__goAnm"};